'use strict';

angular.module('mandaeApp')
  .controller('EnderecoCtrl', function($rootScope, $scope, $stateParams, $state,
    $timeout, $window, localStorageService, FinalizaCadastro, Auth,
    Cep, Cliente, Pedido, Perfil) {

    var vm = this;
    vm.showLoading = false;
    vm.enderecoCarregado = {};
    var user = Perfil.getCacheUserData();
    vm.remetente = user ? user.nome : null;
    vm.telefone = user.telefone != null ? user.telefone.ddd + user.telefone.numero.trim() : null;
    vm.telefoneCarregado = user.telefone;

    // objeto de endereco novo
    vm.coleta = {};
    vm.etiqueta = {};

    Perfil.getActiveAddress(true)
      .then(function(enderecoAtivo) {
        if (enderecoAtivo) {
          angular.copy(enderecoAtivo, vm.enderecoCarregado);
          vm.choseTag = enderecoAtivo.etiqueta ? true : false;

          vm.coleta.endereco = enderecoAtivo == null ? null : {
            "logradouro": enderecoAtivo.logradouro,
            "bairro": enderecoAtivo.bairro,
            "cep": enderecoAtivo.cep,
            "cidade": enderecoAtivo.cidade,
            "numero": enderecoAtivo.numero,
            "complemento": enderecoAtivo.complemento,
            "estado": enderecoAtivo.uf
          };

          vm.remetente = enderecoAtivo ? enderecoAtivo.remetente : vm.remetente,

            vm.etiqueta.endereco = (enderecoAtivo == null || enderecoAtivo.etiqueta == null) ? null : {
              "logradouro": enderecoAtivo.etiqueta.logradouro,
              "bairro": enderecoAtivo.etiqueta.bairro,
              "cep": enderecoAtivo.etiqueta.cep,
              "cidade": enderecoAtivo.etiqueta.cidade,
              "numero": enderecoAtivo.etiqueta.numero,
              "complemento": enderecoAtivo.etiqueta.complemento,
              "estado": enderecoAtivo.etiqueta.uf
            };
          vm.remetenteEtiqueta = vm.etiqueta.endereco ? enderecoAtivo.etiqueta.remetente : null;
          Cep.buscarTipoVeiculoPorCepDadosColeta(enderecoAtivo.cep)
            .then(function(area) {
              // exibe informação de area D+1 e etc...
              vm.verifyArea = true;
              if (area.diaAdicional > 0) {
                vm.areaAtendimento = area;
                vm.tipoColeta = chooseImg(area);
              }
              vm.areaColeta = true;
            })
            .catch(function(err) {
              // exibe informação de fora de area
              if (err.status == 404) {
                vm.areaColeta = false;
                vm.verifyArea = true;
                vm.areaAtendimento = { observacaoCadastro: 'A Mandaê ainda não realiza coletas no endereço informado. Estamos nos esforçando para alcançar as novas áreas em breve.' };
                vm.tipoColeta = chooseImg('fora de area');
              }
            });
        }
      })
      .catch(function(err) {
        console.log(err);
      });

    function chooseImg(area) {
      if (area.diaAdicional > 0) {
        return '/assets/images/icone_area_de_coleta_D+1.svg';
      } else if (area == 'fora de area') {
        return '/assets/images/icone_area_de_coleta_fora_da_area.svg';
      }
    };

    function focusBlankField(item, fieldName) {
      for (var i in item) {
        if (item[i] == "") {
          var nameElement = i + (fieldName ? fieldName : '');
          $timeout(function() {
            document.querySelector('input[name=' + nameElement + ']').focus();
          }, 100);
          break;
        }
      }
    }

    function objetoNuloOuVazio(objeto) {
      return objeto == null || objeto == {};
    }

    function mesmoTelefone(telefone, outroTelefone) {
      if (objetoNuloOuVazio(telefone) && objetoNuloOuVazio(outroTelefone)) {
        return true;
      } else if (!objetoNuloOuVazio(telefone) &&
        !objetoNuloOuVazio(outroTelefone) &&
        telefone.ddd == outroTelefone.ddd &&
        telefone.numero == outroTelefone.numero) {
        return true;
      } else {
        return false;
      }

    }


    function mesmoEndereco(endereco, outroEndereco) {
      if (objetoNuloOuVazio(endereco) && objetoNuloOuVazio(outroEndereco)) {
        return true;
      } else if (!objetoNuloOuVazio(endereco) &&
        !objetoNuloOuVazio(outroEndereco) &&
        endereco.logradouro == outroEndereco.logradouro &&
        endereco.bairro == outroEndereco.bairro &&
        endereco.cep == outroEndereco.cep &&
        endereco.cidade == outroEndereco.cidade &&
        endereco.numero == outroEndereco.numero &&
        endereco.complemento == outroEndereco.complemento &&
        endereco.uf == outroEndereco.uf &&
        endereco.remetente == outroEndereco.remetente &&
        mesmoEndereco(endereco.etiqueta, outroEndereco.etiqueta)) {
        return true;
      } else {
        return false;
      }

    }

    vm.voltar = function() {
      $state.go('gasto-mensal');
    };

    vm.saveItem = function() {
      if (vm.formEnderecoColeta.$valid && (vm.etiqueta.endereco == null || angular.equals(vm.etiqueta.endereco, {}) || vm.formEnderecoEtiqueta.$valid)) {

        var telefone = vm.telefone == undefined ? null : {
          "numero": vm.telefone.substring(2, vm.telefone.length),
          "ddd": vm.telefone.substring(0, 2)
        }

        var enderecoEtiqueta = vm.etiqueta.endereco == null || angular.equals(vm.etiqueta.endereco, {}) ? null : {
          "logradouro": vm.etiqueta.endereco.logradouro,
          "bairro": vm.etiqueta.endereco.bairro,
          "cep": vm.etiqueta.endereco.cep,
          "cidade": vm.etiqueta.endereco.cidade,
          "numero": vm.etiqueta.endereco.numero,
          "complemento": vm.etiqueta.endereco.complemento,
          "uf": vm.etiqueta.endereco.estado,
          "remetente": vm.remetenteEtiqueta
        };

        var endereco = {
          "logradouro": vm.coleta.endereco.logradouro,
          "bairro": vm.coleta.endereco.bairro,
          "cep": vm.coleta.endereco.cep,
          "cidade": vm.coleta.endereco.cidade,
          "numero": vm.coleta.endereco.numero,
          "complemento": vm.coleta.endereco.complemento,
          "uf": vm.coleta.endereco.estado,
          "remetente": vm.remetente,
          "nome": vm.remetente,
          "etiqueta": enderecoEtiqueta,
          "coletaHabilitada": true,
          "logisticaReversaHabilitada": true
        };

        var clienteAlterado = {
          "endereco": !mesmoEndereco(vm.enderecoCarregado, endereco) ? endereco : null,
          "telefone": !mesmoTelefone(vm.telefoneCarregado, telefone) ? telefone : null
        }
        if (clienteAlterado.endereco || clienteAlterado.telefone) {
          FinalizaCadastro.gravarDadosContato(clienteAlterado)
            .then(function(listaEnderecos) {
              //Cliente.atualizarEnderecoAtivo(listaEnderecos);
              //Pedido.atualizarEnderecoPedido(listaEnderecos);
              // chama o perfil do usuario forçando para ir ao back
              Perfil.getUserData(true)
                .then(function(user) {
                  $state.go('documento');
                })
                .catch(function(err) {
                  //showBackMsg(err.data.error.message);
                });
            })
            .catch(function(err) {
              console.log(err);
            });
        } else {
          $state.go('documento');
        }
      } else {
        vm.formEnderecoColeta.$setSubmitted();
        vm.formEnderecoEtiqueta.$setSubmitted();
      }
    };

    vm.fillAddress = function(item, model, label, event) {
      vm.verifyArea = false;
      vm.areaAtendimento = null;
      Cep.buscarTipoVeiculoPorCepDadosColeta(item.cep)
        .then(function(area) {
          // exibe informação de area D+1 e etc...
          vm.verifyArea = true;
          focusBlankField(item);
          if (area.diaAdicional > 0) {
            vm.areaAtendimento = area;
            vm.tipoColeta = chooseImg(area);
          }
          vm.areaColeta = true;
        })
        .catch(function(err) {
          // exibe informação de fora de area
          if (err.status == 404) {
            vm.areaColeta = false;
            focusBlankField(item);
            vm.verifyArea = true;
            vm.areaAtendimento = { observacaoCadastro: 'A Mandaê ainda não realiza coletas no endereço informado. Estamos nos esforçando para alcançar as novas áreas em breve.' };
            vm.tipoColeta = chooseImg('fora de area');
          }
        });
    };

    vm.updateTag = function() {
      var sender = vm.choseTag ? vm.etiqueta : vm.coleta;
      $rootScope.$broadcast('etiqueta:remetente:alterado', sender);

      if (!vm.choseTag) {
        angular.copy({}, vm.etiqueta.endereco);
        vm.remetenteEtiqueta = null;
        angular.element('.autofill-etiqueta').val(null);
      }
    };

    vm.focusField = function(item, model, label, event) {
      focusBlankField(item, 'Etiqueta');
    };
  });
